import React from "react";
import { Text } from "@chakra-ui/react";

import { useStoreTags } from "@hooks";

import { JsonForm, JsonFormControl } from "../JsonForm";
import { StepFrontend } from "@constants";
import { ButtonModal } from "../ModalWrappers";

function download(filename: string, text: string) {
  const element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(text),
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

type AddDownloadDataModalProps = {
  metrologySteps2S: StepFrontend[];
  metrologyStepsPS: StepFrontend[];
  glueSteps2S: StepFrontend[];
  glueHybridSteps2S: StepFrontend[];
  glueStepsPS: StepFrontend[];
};

function makeDownloadDataControl() {
  return [] as JsonFormControl[];
}

export function MakeMetrologyReportsModal({
  metrologySteps2S,
  metrologyStepsPS,
  glueSteps2S,
  glueHybridSteps2S,
  glueStepsPS,
}: AddDownloadDataModalProps) {
  const tags = useStoreTags();
  const tagFormControl = React.useMemo(() => makeDownloadDataControl(), [tags]);
  const [error] = React.useState("");

  let moduleName = "ERROR";
  let gluingJig = "ERROR";
  let hybridJig = "ERROR";
  let user = "ERROR";
  let rotationAngle = "ERROR";
  let xOffset = "ERROR";
  let yOffset = "ERROR";

  let metrologyString =
    "Module,SandwichJig,HybridJig,User,Rotation,x-offset,y-offset\n";

  const doSubmit = React.useCallback(async () => {
    if (metrologySteps2S) {
      metrologySteps2S.forEach((step) => {
        const { moduleId, userName, details } = step;
        glueSteps2S.forEach((glueStep) => {
          if (glueStep.moduleId == moduleId) {
            gluingJig = glueStep.details.sensorGluingFixture as string;
          }
        });
        glueHybridSteps2S.forEach((glueStep) => {
          if (glueStep.moduleId == moduleId) {
            hybridJig = glueStep.details.hybridGluingFixture as string;
          }
        });

        try {
          user = userName;
          rotationAngle = details.rotationAngle as string;
          xOffset = details.sensorParallelOffset as string;
          yOffset = details.sensorPerpendicularOffset as string;
          moduleName = moduleId;
        } catch (ex) {
          console.error("Could not get details");
        }

        metrologyString =
          metrologyString +
          moduleName +
          "," +
          gluingJig +
          "," +
          hybridJig +
          "," +
          user +
          "," +
          rotationAngle +
          "," +
          xOffset +
          "," +
          yOffset +
          "\n";
      });
    }
    if (metrologyStepsPS) {
      metrologyStepsPS.forEach((step) => {
        const { moduleId, userName, details } = step;
        glueStepsPS.forEach((glueStep) => {
          if (glueStep.moduleId == moduleId) {
            hybridJig = glueStep.details.hybridGluingFixture as string;
            gluingJig = "Assembly Robot";
          }
        });

        try {
          user = userName;
          rotationAngle = details.rotationAngle as string;
          xOffset = details.sensorParallelOffset as string;
          yOffset = details.sensorPerpendicularOffset as string;
          moduleName = moduleId;
        } catch (ex) {
          console.error("Could not get details");
        }

        metrologyString =
          metrologyString +
          moduleName +
          "," +
          gluingJig +
          "," +
          hybridJig +
          "," +
          user +
          "," +
          rotationAngle +
          "," +
          xOffset +
          "," +
          yOffset +
          "\n";
      });
    }
    download("metrology.csv", metrologyString);
  }, []);

  return (
    <ButtonModal
      label="Download Metrology Data"
      title="Download Metrology Data"
      size="sm"
    >
      <JsonForm fields={tagFormControl} onSubmit={doSubmit} clearAfterSubmit />
      {error ? <Text>{error}</Text> : undefined}
    </ButtonModal>
  );
}
